import { Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { SelectEmiComponent } from './application/select-emi/select-emi.component';
import { LoginComponent } from './login/login.component';
import { ErrorComponent } from './info-pages/error/error.component';
import { RedirectComponent } from './redirect/redirect.component';
import { EmiResolveService } from './application/select-emi/emi-resolve.service';
import { ApplicationResolveService } from './application/application-resolve.service';
import { DashboardResolveService } from './dashboard/dashboard-resolve.service';
import { RedirectResolveService } from './redirect-resolve.service';
const ɵ0 = () => import("./application/application.module.ngfactory").then(m => m.ApplicationModuleNgFactory), ɵ1 = () => import("./dashboard/dashboard.module.ngfactory").then(m => m.DashboardModuleNgFactory), ɵ2 = () => import("./authentication/authentication.module.ngfactory").then(m => m.AuthenticationModuleNgFactory), ɵ3 = () => import("./info-pages/info-pages.module.ngfactory").then(m => m.InfoPagesModuleNgFactory), ɵ4 = () => import("./aadhaar/aadhaar.module.ngfactory").then(m => m.AadhaarModuleNgFactory), ɵ5 = () => import("./customer/customer.module.ngfactory").then(m => m.CustomerModuleNgFactory), ɵ6 = () => import("./risk/risk.module.ngfactory").then(m => m.RiskModuleNgFactory), ɵ7 = () => import("./repayments/repayments.module.ngfactory").then(m => m.RepaymentsModuleNgFactory), ɵ8 = () => import("./landing-pages/landing-pages.module.ngfactory").then(m => m.LandingPagesModuleNgFactory), ɵ9 = () => import("./offline-landing-pages/offline-landing-pages.module.ngfactory").then(m => m.OfflineLandingPagesModuleNgFactory), ɵ10 = () => import("./widgets/widgets.module.ngfactory").then(m => m.WidgetsModuleNgFactory), ɵ11 = () => import("./features/features.module.ngfactory").then(m => m.FeaturesModuleNgFactory);
const routes = [
    {
        path: '',
        component: SelectEmiComponent,
        resolve: {
            recommendedAndOtherEMIPlans: EmiResolveService,
            application: ApplicationResolveService
        }
    }, {
        path: 'application',
        loadChildren: ɵ0
    }, {
        path: 'loggedinredirect',
        component: LoginComponent
    }, {
        path: 'dashboard',
        loadChildren: ɵ1,
        resolve: {
            journey: DashboardResolveService
        }
    }, {
        path: 'authentication',
        loadChildren: ɵ2,
        resolve: {
            component: RedirectResolveService
        }
    }, {
        path: 'info-page',
        loadChildren: ɵ3
    }, {
        path: 'ekyc',
        loadChildren: ɵ4
    }, {
        path: 'customer',
        loadChildren: ɵ5,
    }, {
        path: 'risk',
        loadChildren: ɵ6,
        canActivate: [AuthGuardService]
    }, {
        path: 'repayments',
        loadChildren: ɵ7,
        canActivate: [AuthGuardService]
    }, {
        path: 'emi',
        loadChildren: ɵ8
    }, {
        path: 'stores',
        loadChildren: ɵ9
    }, {
        path: 'widgets',
        loadChildren: ɵ10
    }, {
        path: 'features',
        loadChildren: ɵ11
    }, {
        path: 'redirect',
        component: RedirectComponent
    }, {
        path: '**',
        component: ErrorComponent
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
